import React from "react";
import parse from 'html-react-parser';
import loginIcon from "../../../assets/images/pilot/Vector.png";
import brandUptime from "../../../assets/images/pilot/branduptime.svg";
import {
  StyledContainer,
  StyledTopNav,
  StyledHeader,
  StyledLogo,
  StyledGrid,
  StyledTypography,
  StyledLink,
} from "./oauthErrorMode.style";

export interface IOauthErrorMode {
  logoImg: any;
  loginPath: string;
  brand: any;
  content?: any;
  error: any;
  mainImg?: any;
}

const oauthErrorMode = (props: IOauthErrorMode) => {
  const { logoImg, loginPath, brand, content, error, mainImg } = props;

  const linkSharePoint = "https://dxcportal.sharepoint.com/sites/uptimeresources";
  
  const HandleLogin = () =>{
    localStorage.clear();
  };

  const mockContent = (content: any) => (
    <>
      <StyledTypography className="main">
        {error?.name}
        {!!error?.name && !!error?.message && `:`} {error?.message}
      </StyledTypography>
      <StyledLogo className="brand" src={brand || brandUptime} alt="logo" />

      {!!content ? (
        parse(content)
      ) : (
        <>
          <StyledTypography>
            <b>
              Thanks for stopping by to check out UPtime. Currently, we're not
              quite ready for you to log in.
            </b>
            <br />
            Please contact IT support agent.
          </StyledTypography>

          <StyledTypography>
            Our portal includes <br />
            <StyledTypography className="list">
              <li>Order devices for yourself</li>
              <li>Ability to order on behalf of other users</li>
              <li>Manage devices, requests and incidents</li>
              <li>Approver view to act on orders pending your action</li>
            </StyledTypography>
            Want more info? Check out{" "}
            <StyledLink className="link" href={linkSharePoint}>
              UPtime Resources SharePoint Site
            </StyledLink>
            <br />
          </StyledTypography>
          <StyledTypography>
            Thanks,
            <br />
            Team UPtime
          </StyledTypography>
        </>
      )}
    </>
  );

  return (
    <>
      <StyledTopNav>
        <StyledHeader>
          <div className="header-left">
            <StyledLink href="">
              <StyledLogo className="logo" src={logoImg} alt="logo" />
            </StyledLink>
          </div>
          <div className="header-right">
            <StyledLink href={loginPath} onClick={HandleLogin}>
              <StyledLogo className="icon" src={loginIcon} alt="logo" />
            </StyledLink>
          </div>
        </StyledHeader>
      </StyledTopNav>
      <StyledContainer>
        <StyledGrid container>
          <StyledGrid item xs={7} className="content-left">
            <StyledLogo className="main-image" src={mainImg} alt="img" title="Main Image" />
          </StyledGrid>
          <StyledGrid item xs={5} className="content-right">
            {mockContent(content)}
          </StyledGrid>
        </StyledGrid>
      </StyledContainer>
    </>
  );
};

export default oauthErrorMode;
